import { useState } from "react";
import { toast } from "sonner";
import { Bell, Check } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export function NotifyForm({ show, testid = "notify" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || busy) return;
    setBusy(true);
    try {
      await api.post("/notify", { email: email.trim(), show });
      setDone(true);
      toast.success(`You're on the list for ${show}`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not sign up");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 text-gold text-sm font-mono-imn uppercase tracking-widest" data-testid={`${testid}-done`}>
        <Check size={16} /> You're on the list — we'll email you at launch
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md" data-testid={`${testid}-form`}>
      <div className="relative flex-1">
        <Bell size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email for launch alerts"
          data-testid={`${testid}-email`}
          className="w-full bg-white/5 border border-white/15 pl-9 pr-3 py-3 text-sm outline-none focus:border-gold transition-colors"
        />
      </div>
      <button
        type="submit"
        disabled={busy}
        data-testid={`${testid}-submit`}
        className="bg-gold text-black font-semibold px-6 py-3 text-sm uppercase tracking-wider hover:opacity-90 active:scale-95 transition-all disabled:opacity-50 whitespace-nowrap"
      >
        {busy ? "…" : "Notify Me"}
      </button>
    </form>
  );
}
